import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import {
    EventUrgencySignalsData,
    UrgencySignalsKeys,
} from '../../types/events';
import './EventCardUrgencySignals.scss';

export type EventCardUrgencySignalsProps = {
    urgencySignals: EventUrgencySignalsData;
    className?: string;
};

export function EventCardUrgencySignals({
    urgencySignals,
    className,
}: EventCardUrgencySignalsProps) {
    const urgencySignal = getUrgencySignal(urgencySignals);

    if (!urgencySignal) {
        return null;
    }

    const { className: containerClassName, label } = urgencySignal;
    return (
        <aside
            className={classNames(
                className,
                'EventCardUrgencySignal',
                containerClassName,
            )}
        >
            <Typography
                className="EventCardUrgencySignal__label"
                variant="body-md-bold"
            >
                {label}
            </Typography>
        </aside>
    );
}

const urgencySignalsData = {
    [UrgencySignalsKeys.fewTickets]: {
        label: gettext('Almost full'),
        className: 'EventCardUrgencySignal--almost-full',
    },
    [UrgencySignalsKeys.salesEndSoon]: {
        label: gettext('Sales end soon'),
        className: 'EventCardUrgencySignal--sales-end-soon',
    },
    [UrgencySignalsKeys.earlyBird]: {
        label: gettext('Early access'),
        className: 'EventCardUrgencySignal--early-access',
    },
    [UrgencySignalsKeys.popular]: {
        label: gettext('Popular'),
        className: 'EventCardUrgencySignal--popular',
    },
    [UrgencySignalsKeys.new]: {
        label: gettext('Just added!'),
        className: 'EventCardUrgencySignal--just-added',
    },
};

const urgencySignalPriority = [
    UrgencySignalsKeys.fewTickets,
    UrgencySignalsKeys.salesEndSoon,
    UrgencySignalsKeys.earlyBird,
    UrgencySignalsKeys.popular,
    UrgencySignalsKeys.new,
];

function getUrgencySignal(currentUrgencySignals: EventUrgencySignalsData) {
    const activeUrgencySignal = urgencySignalPriority.find(
        (urgencySignal) => currentUrgencySignals[urgencySignal],
    );
    return activeUrgencySignal
        ? urgencySignalsData[activeUrgencySignal]
        : undefined;
}
